import type { InferedAnnotation } from './types';

export const INFERED_ANNOTATIONS: InferedAnnotation = {};
